import React, { useState } from 'react';
import { BygrUserDetails, BygrUserProfileMembership } from '@/types';
import { createDataTable } from '@/components/DataTable';
import { CustomLink } from '@ygtechnologies/bygr-frontend-component-library';

export interface UserProfilesProps {
    user: BygrUserDetails;
    reload(): void;
}
const MemberDataTable = createDataTable<BygrUserProfileMembership>();

export const UserProfiles: React.FC<UserProfilesProps> = ({ user }) => {
    const [memberTableState, setMemberTableState] = useState(MemberDataTable.getInitialState('profileId'));

    return (
        <MemberDataTable
            hasPagination={false}
            data={user.profileMemberships}
            onStateChange={setMemberTableState}
            state={memberTableState}
            totalItemCount={user.projectMemberships.length}
            className="table style-3">
            <MemberDataTable.Column header="Profile Id" field="profileId" renderer={({ value }) => value} />
            <MemberDataTable.Column
                header="Profile"
                field="profileName"
                renderer={({ value, row }) => <CustomLink to={`/profiles/${row.profileId}`}>{value}</CustomLink>}
            />
            <MemberDataTable.Column header="Module" field="profileType" />
        </MemberDataTable>
    );
};
